import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62315d29"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40px",
  height: "40px",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_429_11066)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 6.00092H21M3 12.0009H21M3 18.0009H21",
      stroke: "#e73d38",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_429_11066" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0 0.000915527)"
      })
    ])
  ])
], -1))
const _hoisted_2 = { class: "layout-topbar-icons p-d-flex p-justify-between p-align-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-lg-center p-flex-wrap p-align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Gamification = _resolveComponent("Gamification")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_creator_menu = _resolveComponent("creator-menu")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_CampaignTypeDialog = _resolveComponent("CampaignTypeDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.shouldShowElement)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["layout-topbar", {
    'layout-topbar-big': !_ctx.isSmallSidebar, 'scroll-topbar': !_ctx.scrollY,
    'background-dark': _ctx.isNewDesignEnabled, 'topbar-with-warning': _ctx.isNewDesignEnabled && !_ctx.isDashboard && !_ctx.isWhiteListing
  }])
        }, [
          _createVNode(_component_Button, {
            onClick: _ctx.toggleMenu,
            class: "menu-toggle-button"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.isNewDesignEnabled && (_ctx.userIsBrand || _ctx.isAdmin))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "new-button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDialog(true,'')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("+ New Campaign")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Gamification, { style: {"display":"none"} }),
              _createVNode(_component_Notifications, { "is-brand": _ctx.userIsBrand }, null, 8, ["is-brand"]),
              _createVNode(_component_creator_menu),
              _createVNode(_component_Menu, {
                id: "menu",
                ref: "menuRef",
                model: _ctx.userMenuItems,
                popup: true,
                appendTo: 'body'
              }, null, 8, ["model"])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.openDialog)
      ? (_openBlock(), _createBlock(_component_CampaignTypeDialog, {
          key: 1,
          open: _ctx.openDialog,
          close: _ctx.handleDialog,
          submit: _ctx.handleDialog
        }, null, 8, ["open", "close", "submit"]))
      : _createCommentVNode("", true)
  ], 64))
}